export default __webpack_public_path__ + "static/media/0.65dd27b0.png";